import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import styles from "./styles.module.scss";
import CreateOrganizationForm, {
  ISubmittedOrganization,
} from "./CreateOrganizationForm";
import OrganizationReviewCard from "./OrganizationReviewCard";

interface Props {
  rejectionReason?: string;
  onResubmit: (organization?: ISubmittedOrganization) => void;
  name?: string;
  websiteUrl?: string;
  description?: string;
}

const OrganizationRejected: React.FC<Props> = ({
  rejectionReason,
  onResubmit,
  name,
  websiteUrl,
  description,
}) => {
  const { t } = useTranslation();
  // The rejection notice comes first; the prefilled form only appears once the user opts in
  // via the call-to-action, so the reason has a chance to be read before the fields appear.
  const [editing, setEditing] = useState(false);

  if (editing) {
    return (
      <div className={styles.gateFormContainer}>
        <CreateOrganizationForm
          onSubmitted={onResubmit}
          initialValues={{ name, websiteUrl, description }}
        />
      </div>
    );
  }

  return (
    <OrganizationReviewCard
      variant="rejected"
      title={t("lbl_org_rejected_title")}
      description={rejectionReason || t("lbl_org_rejected_subtitle")}
      descriptionClassName={styles.reviewReason}>
      <div className={styles.reviewAction}>
        <button type="button" onClick={() => setEditing(true)}>
          {t("lbl_org_rejected_refill")}
        </button>
      </div>
    </OrganizationReviewCard>
  );
};

export default OrganizationRejected;
